<!--
 * @Author: kunlv kunlv@iflytek.com
 * @Date: 2026-01-16 15:29:30
 * @LastEditors: kunlv kunlv@iflytek.com
 * @LastEditTime: 2026-01-19 10:56:29
 * @FilePath: \ai-official-yg\src\views\case\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="page">
    <page-header />
    <div class="page__content">
      <component
        :is="component"
        :key="id" />
    </div>
  </div>
</template>
<script>
  import case1 from "./case1.vue";
  import case2 from "./case2.vue";
  import case3 from "./case3.vue";
  import case4 from "./case4.vue";
  import PageHeader from "@/components/pageHeader";
  export default {
    name: "Case",
    props: {
      id: {
        type: [String, Number],
        default: 1
      }
    },
    components: {
      case1,
      case2,
      case3,
      case4,
      PageHeader
    },
    computed: {
      component() {
        const id = Number(this.id) || 1;
        // 确保组件名称在 components 中已注册
        const componentName = `case${id}`;
        return this.$options.components[componentName] ? componentName : 'case1';
      }
    }
  }
</script>
<style lang="scss" scoped>
.page {
  --page-padding: 368px;
  padding-top: 60px;
  height:100vh;
  width: 100%;
  background: #F3F8FF;
  &__content {
    padding: 32px 0;
    width: 100%;
    height:100%;
    overflow-y: auto;
    background-image: url("~@/assets/images/case/bg@1x.png");
    background-size: 100% 100%;
    background-position: 0 0;
    background-repeat: no-repeat;
  }
 
}
</style>